<template>
  <div v-loading="videoLoading" class="video">
    <div class="select-music">选择视频</div>
    <div class="drop-out" @click="videoout">
      <img alt="" :src="g_imgSrc.delete" class="out" @click="videoout" />
    </div>

    <div style="overflow: hidden">
      <tagSelect v-if="type === 'public'" class="tag-select" @emitAddPublic="emitAddPublic" />
      <tagSelectAgent v-else class="tag-select" @emitAddPublic="emitAddPublic" />
      <el-button @click="uploadvideo">上传视频</el-button>
    </div>
    <div v-if="datalist.length > 0" class="music-list">
      <div class="box" :class="{ isSelect: data.select }" :key="data.id" v-for="data in datalist">
        <span
          class="button-select"
          :class="{ isSelect: data.select }"
          @click="changeSelect(data)"
        />

        <div class="music-box" v-if="sw">
          <video class="music-box-img" controls="controls">
            <source :src="data.mate_data" />
          </video>
        </div>
        <div class="video-title">
          {{ data.mate_name }}
        </div>
        <statusTag :list="data.agents" v-if="data.agents.length" />
      </div>
    </div>
    <div v-if="datalist.length === 0" class="noDatalist">
      <img alt="" :src="g_imgSrc.bgWhite" class="noDatalist-img" />
      <div class="release-list-noData-word">暂无相关内容</div>
    </div>
    <el-pagination
      v-if="datalist.length > 0"
      class="pagination"
      style="background-color: #ffffff"
      layout="total, prev, pager, next, jumper"
      :total="total"
      :page-size="size"
      @current-change="handleCurrentChange"
    />
    <div slot="footer" class="dialog-footer" v-if="datalist.length > 0">
      <el-button class="closeCancel" @click="videoout">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>
<script>
import { EyaoSaaSSelectMaterialApi } from '@/api/releaseManagement';
// import tagSelect from '@/components/tagSelect';
import tagSelectAgent from '@/components/tagSelectAgent';
import tagSelect from '@/components/tagSelect';
import statusTag from '@/components/statusTag';
export default {
  components: { tagSelect, tagSelectAgent, statusTag },
  props: {
    type: {
      type: String,
      default: 'public',
    },
    videoClose: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      sw: true,
      file_type: 2, //  1->图片   3->音频   2->视频
      filesName: '', // 图片流
      videoName: '', // 视频名称
      key_words: '', // 标题
      title: '', // 视频介绍
      total: 1,
      size: 6, // 每页数量
      currentPage: 1, // 页数
      videoLoading: false, // loading
      imgloading: false, // img loading
      sortList: [], // 勾选为true的数组
      datalist: [], // 获取数组
      openVideodialog: false, // 添加视频的loading
      agentIds: [],
    };
  },
  mounted() {
    this.getdataList();
  },
  methods: {
    emitAddPublic(list) {
      this.agentIds = list.map((item) => item.value);
      this.getdataList(1);
    },
    getdataList(page) {
      if (page) {
        this.currentPage = page;
      }
      let mode = 1;
      if (this.type === 'public') {
        mode = 1;
      } else if (this.type === 'app') {
        mode = 2;
      }
      console.log(mode);
      this.videoLoading = true;
      const req = {
        mate_type: this.file_type,
        page_size: this.size,
        page_index: this.currentPage,
        appids: this.type === 'public' ? this.agentIds : [],
        agent_ids: this.type !== 'public' ? this.agentIds : [],
        mode,
      };
      EyaoSaaSSelectMaterialApi(req)
        .then((res) => {
          this.total = res.total;
          this.datalist = res.mate_list.map((item) => {
            item = Object.assign(item, { select: false });
            return item;
          });
          this.videoLoading = false;
        })
        .catch(() => {
          this.videoLoading = false;
          this.$message('查询失败');
        });
    },
    changeSelect(i) {
      this.datalist = this.datalist.map((item) => {
        if (item.mate_id === i.mate_id) {
          item.select = !item.select;
          if (item.select) {
            this.sortList.push(item);
          } else {
            const arr = [];
            this.sortList.forEach((soltItem) => {
              if (soltItem.mate_id !== i.mate_id) {
                arr.push(soltItem);
              }
            });
            this.sortList = arr;
          }
        }
        return item;
      });
    },
    uploadvideo() {
      this.g_tourl(`/saas/materialManagement/material-video-upload.html`, { open: true });
    },
    confirm() {
      this.videoClose();
      this.$emit('videoDatalist', this.sortList);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.videoLoading = true;
      let mode = 1;
      if (this.type === 'public') {
        mode = 1;
      } else if (this.type === 'app') {
        mode = 2;
      }
      console.log(mode);
      const req = {
        mate_type: this.file_type,
        page_size: this.size,
        page_index: this.currentPage,
        appids: this.type === 'public' ? this.agentIds : [],
        agent_ids: this.type !== 'public' ? this.agentIds : [],
        mode,
        // mode: 2,
      };
      EyaoSaaSSelectMaterialApi(req)
        .then((res) => {
          this.datalist = res.mate_list.map((item) => {
            item = Object.assign(item, { select: false });
            return item;
          });
          if (this.sortList.length > 0) {
            this.datalist = this.datalist.map((item) => {
              item = Object.assign(item, { select: false });
              this.sortList.forEach((sortItem) => {
                if (sortItem.mate_id === item.mate_id) {
                  item.select = true;
                }
              });
              return item;
            });
          }
          this.sw = false;
          this.$nextTick(() => {
            this.sw = true;
          });
          this.videoLoading = false;
        })
        .catch(() => {
          this.videoLoading = false;
          this.$message('查询失败');
        });
    },
    videoout() {
      this.sortList = [];
      this.videoClose();
    },
  },
};
</script>
<style scoped lang="scss">
.video {
  .tag-select {
    width: 80%;
    float: left;
    margin: 49px 0 0 20px;
  }
  .select-music {
    font-size: 16px;
    font-weight: 400;
    margin-left: 24px;
  }
  .drop-out {
    height: 18px;
    width: 20px;
    position: absolute;
    top: 30px;
    right: 44px;
    cursor: pointer;
    .out {
      width: 100%;
      cursor: pointer;
    }
  }
  .music-list {
    margin: 20px -16px 0 20px;
    .box {
      position: relative;
      width: 290px;
      height: 260px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      display: inline-block;
      margin-right: 16px;
      margin-bottom: 24px;
      border-radius: 4px;
      overflow: hidden;
      &.isSelect {
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: rgba(47, 150, 255, 0.15);
          border: 2px solid #2f96ff;
          border-radius: 4px;
        }
      }
      .button-select {
        position: absolute;
        background: rgba(48, 49, 51, 0.1);
        border: 1px solid #c0c4cc;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        right: 10px;
        top: 10px;
        z-index: 9;
        cursor: pointer;
        &.isSelect {
          background: #2f96ff;
          border: 1px solid #ffffff;
          &::after {
            content: '';
            width: 8px;
            height: 8px;
            position: absolute;
            left: 50%;
            top: 50%;
            border-radius: 50%;
            margin: -4px 0 0 -4px;
            background: #ffffff;
          }
        }
      }
      .title {
        width: 140px;
        height: 20px;
        position: absolute;
        top: 12px;
        left: 50px;
        font-size: 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .music-box {
        width: 290px;
        height: 160px;
        // border: 1px solid rgba(0,0,0,0.08);
        .music-box-img {
          height: 100%;
          object-fit: fill;
          width: 100%;
        }
      }
      .video-title {
        width: 100px;
        font-size: 16px;
        padding: 12px 12px 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .box:hover {
      border: 1px solid #2f96ff;
    }
  }
  .noDatalist {
    width: 100%;
    text-align: center;
    .noDatalist-img {
      width: 240px;
      height: 190px;
      margin-top: 10vh;
    }
  }
  .dialog-footer {
    text-align: center;
    margin-top: 20px;
    .closeCancel {
      border: 1px solid #dcdfe6;
      background: #ffffff;
      color: #606266;
    }
    .closeCancel:hover {
      background: rgba(0, 0, 0, 0.04);
      color: #606266;
    }
  }
  .dialog-footer ::v-deep .el-button span {
    font-weight: normal;
  }
  .pagination {
    text-align: right;
  }
  .pagination ::v-deep .el-pager li.number {
    color: #606266;
  }
  .pagination ::v-deep .el-pager li.active {
    color: #2f96ff !important;
  }
  .pagination ::v-deep .el-input__inner {
    width: 46px;
    border-radius: 3px;
    height: 24px;
  }
}
.el-button--primary:hover {
  background: #63b0ff;
  color: #ffffff;
}
.video .sort-bg .sort-box .button .up-footer-btn:hover {
  background: #63b0ff;
  color: #ffffff;
}
</style>
